export default "__VITE_ASSET__pWcU2WDI__"